/*
  Zugo - urun seridi.

  Iki isi var:

  1) Kaydirma. Swiper yerine tarayicinin kendi kaydirmasi (`scroll-snap`)
     kullanilir; dokunmatikte zaten dogru calisir, oklar ve noktalar
     sadece onu tetikler. Ekran genisligine gore kac urun gorundugu
     degistigi icin (mobil 1.2, tablet 3, masaustu 4) nokta sayisi
     olcumle uretilir - sabit sayilmaz.

  2) Oneri motoru. `data-oneri-adresi` varsa Shopify'in oneri ucundan
     bolum yeniden istenir. Donen listede urun VARSA serit onunla
     degistirilir; BOSSA sayfada zaten duran yedek liste (urunun kendi
     kategorisi) yerinde birakilir. Boylece serit hicbir durumda bos
     kalmaz ve JavaScript kapaliyken de doludur.
*/
/*
  Bolum sayfada IKI KEZ kullanildigi icin bu dosya iki <script> etiketiyle
  gelir. Ust duzeyde `class` tanimi ikinci calistirmada "already been
  declared" hatasi veriyordu; blok icine alinca tanim yerel kalir.
*/
(() => {
  class ZugoUrunSerit extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-serit-track]');
      this.noktalar = this.querySelector('[data-serit-noktalar]');
      this.oklar = [...this.querySelectorAll('[data-yon]')];

      if (!this.track) return;

      this.onScroll = this.debounce(() => this.durumGuncelle(), 90);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.oklar.forEach((btn) =>
        btn.addEventListener('click', () => this.kaydir(btn.dataset.yon === 'sonraki' ? 1 : -1))
      );

      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.debounce(() => this.noktalariKur(), 120));
        this.observer.observe(this.track);
      }

      this.noktalariKur();

      if (this.dataset.oneriAdresi) this.onerileriGetir();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    async onerileriGetir() {
      try {
        const yanit = await fetch(this.dataset.oneriAdresi);
        if (!yanit.ok) return;

        const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
        const yeniSerit = belge.querySelector('[data-serit-track]');

        // Motor bos donduyse yedek listeye DOKUNMA.
        if (!yeniSerit || yeniSerit.children.length === 0) return;

        this.track.innerHTML = yeniSerit.innerHTML;
        this.track.scrollLeft = 0;
        this.noktalariKur();

        // Hizli ekleme / renk secenegi gibi kart ici davranislar temanin
        // kendi ozel etiketlerinden gelir; yeni gelen HTML'de bunlarin
        // baglanmasi icin tema olayini tetikle.
        document.dispatchEvent(new CustomEvent('zugo:serit-yenilendi', { detail: { serit: this } }));
      } catch (e) {
        // Sessiz gec - yedek liste zaten ekranda.
      }
    }

    get sayfaGenisligi() {
      return this.track.clientWidth;
    }

    get sayfaSayisi() {
      return Math.max(1, Math.round(this.track.scrollWidth / this.sayfaGenisligi));
    }

    get aktifSayfa() {
      return Math.round(this.track.scrollLeft / this.sayfaGenisligi);
    }

    noktalariKur() {
      const adet = this.sayfaSayisi;

      if (!this.noktalar) return;

      if (adet < 2) {
        this.noktalar.innerHTML = '';
        this.oklar.forEach((b) => (b.disabled = true));
        return;
      }

      if (this.noktalar.children.length !== adet) {
        this.noktalar.innerHTML = '';
        for (let i = 0; i < adet; i += 1) {
          const nokta = document.createElement('button');
          nokta.type = 'button';
          nokta.className = 'zugo-serit__nokta';
          nokta.setAttribute('aria-label', `${i + 1}`);
          nokta.addEventListener('click', () => {
            this.track.scrollTo({ left: i * this.sayfaGenisligi, behavior: 'smooth' });
          });
          this.noktalar.appendChild(nokta);
        }
      }

      this.durumGuncelle();
    }

    durumGuncelle() {
      const aktif = this.aktifSayfa;
      const son = this.sayfaSayisi - 1;

      [...this.noktalar.children].forEach((d, i) =>
        d.setAttribute('aria-current', i === aktif ? 'true' : 'false')
      );

      this.oklar.forEach((b) => {
        b.disabled = b.dataset.yon === 'sonraki' ? aktif >= son : aktif <= 0;
      });
    }

    kaydir(yon) {
      this.track.scrollBy({ left: yon * this.sayfaGenisligi, behavior: 'smooth' });
    }

    debounce(fn, ms) {
      let t;
      return (...a) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, a), ms);
      };
    }
  }

  if (!customElements.get('zugo-urun-serit')) {
    customElements.define('zugo-urun-serit', ZugoUrunSerit);
  }
})();
